import React from "react";
import { Link } from "react-router-dom";
import { imageUrl } from "@/lib/api";

const WatchCard = ({ watch }) => {
  const cover = watch.images?.[0];
  return (
    <Link
      to={`/watches/${watch.id}`}
      data-testid={`watch-card-${watch.id}`}
      className="watch-card group block"
    >
      <div className="relative aspect-[4/5] overflow-hidden bg-[var(--aq-surface)] flex items-center justify-center p-2 sm:p-3">
        {watch.is_new_arrival && (
          <span
            data-testid="badge-new-arrival"
            className="absolute top-4 left-4 z-10 bg-white text-[10px] tracking-[0.28em] uppercase px-3 py-1 border border-black/10"
          >
            Nuevo
          </span>
        )}
        {cover ? (
          <img
            src={imageUrl(cover)}
            alt={watch.name}
            loading="lazy"
            className="watch-card-img w-[88%] h-[88%] object-contain"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-[var(--aq-muted)] text-sm">Sin imagen</div>
        )}
      </div>
      <div className="mt-6 px-1 text-center">
        <div className="overline mb-2">{watch.collection}</div>
        <h3 className="font-display text-lg sm:text-xl text-[var(--aq-ink)] mb-1.5">{watch.name}</h3>
        <p className="text-xs text-[var(--aq-muted)] tracking-wide">{watch.movement}</p>
        {watch.pricing_mode === "quote" ? (
          <p className="mt-3 text-sm text-[var(--aq-ink)] font-medium">Solicitar cotización</p>
        ) : watch.price ? (
          <p className="mt-3 text-sm text-[var(--aq-ink)] font-medium">{watch.price}</p>
        ) : null}
        <span className="inline-block mt-5 text-[10px] uppercase tracking-[0.28em] border-b border-black pb-0.5">
          Ver Detalles
        </span>
      </div>
    </Link>
  );
};

export default WatchCard;
